import React from "react";

export const MusicPlayerContext = React.createContext();
